import React, { useEffect, useState } from "react";
import { Grid, Box, Button, IconButton, Modal, Typography } from "../../components/ui";
import { Add, Delete, Edit } from "../../components/icons";
import { toast } from "react-toastify";
import axiosInstance from "../../axios/axiosInstance";
import { modalStyle } from "../../style/common";
import BlockFrom from "./components/BlockFrom";

const Blocks = () => {
  const [open, setOpen] = useState<boolean>(false);
  const [blocks, setBlocks] = useState<any>([]);
  const [id, setId] = useState<any>(null);

  const handleOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
    handleGetBlocks();
    setId(null);
  };

  const handleGetBlocks = async () => {
    try {
      const resp: any = await axiosInstance.get(`/api/block`);
      if (resp?.status === 200) {
        setBlocks(resp?.data?.data);
      }
    } catch (error: any) {
      toast.error(error?.response?.data?.body);
    }
  };
  const handleDelete = async (id: any) => {
    try {
      const resp: any = await axiosInstance.delete(`/api/block/${id}`);
      if (resp?.status === 200) {
        handleGetBlocks();

        toast.success("Block deleted Successfully");
      }
    } catch (error: any) {
      toast.error(error?.response?.data?.body);
    }
  };

  useEffect(() => {
    handleGetBlocks();
  }, []);
  return (
    <div>
      <Grid container p={2} px={{ md: 10, xs: 5 }}>
        <Grid size={12}>
          <Button onClick={handleOpen} sx={{ textTransform: "none" }}>
            <Typography fontSize={20} fontWeight={500} color="#111827">
              Blocks
              <IconButton onClick={handleOpen}>
                <Add sx={{ color: "#111827" }} />
              </IconButton>
            </Typography>
          </Button>
        </Grid>
        <Grid
          size={12}
          container
          mt={2}
          py={1}
          bgcolor={"#111827"}
          borderRadius={1}
          color={"whitesmoke"}
        >
          <Grid size={1}>
            <Typography fontSize={17} fontWeight={500} align="center">
              Sl no
            </Typography>
          </Grid>
          <Grid size={8}>
            <Typography fontSize={17} fontWeight={500} align="center">
              Blocks
            </Typography>
          </Grid>
          <Grid size={3}>
            <Typography fontSize={17} fontWeight={500} align="center">
              Action
            </Typography>
          </Grid>
        </Grid>
        {blocks?.map((item: any, index: any) => (
          <Grid size={12} container borderBottom={"1px solid #111827"} py={2}>
            <Grid size={1}>
              <Typography fontSize={17} align="center">
                {" "}
                {index + 1}
              </Typography>
            </Grid>
            <Grid size={8}>
              <Typography fontSize={17} align="center">
                {" "}
                {item?.block_name}
              </Typography>
            </Grid>
            <Grid
              size={3}
              sx={
                item?.is_request_send && {
                  pointerEvents: "none",
                  opacity: 0.6,
                }
              }
            >
              <Typography fontSize={17} align="center">
                <IconButton
                  onClick={() => {
                    setId(item?.id);
                    handleOpen();
                  }}
                >
                  <Edit sx={{ color: "#111827" }} />
                </IconButton>
                <IconButton onClick={() => handleDelete(item?.id)}>
                  <Delete sx={{ color: "#111827" }} />
                </IconButton>
              </Typography>
            </Grid>
          </Grid>
        ))}
      </Grid>
      <Modal onClose={handleClose} open={open}>
        <Box sx={modalStyle}>
          <BlockFrom onClose={handleClose} id={id} />
        </Box>
      </Modal>
    </div>
  );
};

export default Blocks;
